module.exports = __webpack_public_path__ + "/font/fontawesome-webfont_a3de21.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.5.0
 ** module id = 476
 ** module chunks = 0
 **/